"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var removeNotification_1 = __importDefault(require("../actions/removeNotification"));
function removeExpiredNotificationsSchedule(dispatch, getState) {
    var _a;
    var state = getState();
    (_a = state.notifications) === null || _a === void 0 ? void 0 : _a.forEach(function (notification) {
        if (notification.expireAt && notification.expireAt <= Date.now()) {
            dispatch((0, removeNotification_1.default)(notification.id));
        }
    });
}
exports.default = removeExpiredNotificationsSchedule;
//# sourceMappingURL=removeExpiredNotifications.js.map